import { PurchaseOrderService } from './../../../../service/vendor/purchase-order.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { TreeNode } from 'primeng/api';
import { TreeTable } from 'primeng/treetable';
import { FilterPoData } from '../../../../models/filter-data-po';
import { DatePipe } from '@angular/common';
import { MessageService } from 'primeng/api';
import { CreateDeliverySchedule } from '../../../../models/create-delivery-schedule';
import { AuthService } from '../../../../service/frappe/auth.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router, RouterStateSnapshot } from '@angular/router';
import { PoSearchDTO } from '../../../../models/PoSearchDTO1';
import * as XLSX from 'xlsx';
import { VendorTsService } from '../../../../service/vendor/vendor.ts.service';
import { ShipmentASN } from '../../../../service/shipment-asn.service';

interface Column {
  field: string;
}
interface PlantWithCode{
  plant__code:string
  name1:string
}
interface FilterDate{
  startDate:any
  endDate:any
  poAgreementNos :string
  plants :string
  vendorNames :string
}

@Component({
  selector: 'app-view-purchase-order',
  templateUrl: './view-purchase-order.component.html',
  styleUrl: './view-purchase-order.component.scss'
})
export class ViewPurchaseOrderComponent implements OnInit {

  @ViewChild('tt') tt?: TreeTable;
  visible: boolean = false;
  visible1: boolean = false;
  poList!: any[];
  mappedData?: any[]
  files!: TreeNode[];
  // rows:number=10;
  limit:number=10;
  currentPage:number=1;
  totalRecords:number=0
  po_item_no?: string
  cols!: Column[];

  deliverySchedule?: CreateDeliverySchedule;
  filters?: FilterPoData;


  companyCode: string = '';
  plant: string = '';
  docType: string = '';
  docCat: string = '';
  poAgreementNo: string = '';
  vendorCode: string = '';
  status: string = '';
  documentDate: Date | undefined;
  validFromDate: Date | undefined;
  validToDate: Date | undefined;
  selectedPerentKey: any;
  selectedChildKey: any;
  currentNodePo: string = ''

  deliveryScheduleForm!: FormGroup
  loggedInUsers: string | undefined;
  poItemNo?: string
  schedule_remaining_quantity?: string
  po_agreement_no?: string
  po_order_type?: string

  maxAllowedQuantity?: number
  totalQuantity = 0
  availableQuantity!: number
  scheduleList!: any[];
  quantityExceedsMax: boolean = false;
  saveButtonDisabled: boolean = false;

  dateValidation: boolean = false;
  correctDate: Date = new Date();

  isContentVisible = false;

  selectedPOData: any[] = []
  selectedPOItemData: any[] = []
  selectedPOZSERItemData: any[] = []
  selectedPOScheduleData: any[] = []
  selectedPOScheduleData2: any[] = []
  po_no: string = '';
  schedule_item_no: string = '';
  sidebarVisible: boolean = false
  poNo: string = '';
  isLoading: boolean = false;

  PoSearchDTO?:PoSearchDTO
  isExcel: boolean = false;
  startDate: Date | null = null;
  endDate: Date | null = null;
  dateValidation1: boolean = false;
  poAgreementNos :string =''
  plants :string =''
  vendorNames :string =''
  isPlantRole:boolean =false
  isVendor:boolean =false
  isZserPOVisible:boolean =false
  isZserPO:boolean =false
  plantList: any[] = [];

  selectedPODetail: any
  totalQuantity2: number = 0

  constructor(
    private purchaseOrder: PurchaseOrderService,
    private auth: AuthService,
    private datePipe: DatePipe,
    private messageService: MessageService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private vendorService: VendorTsService,
    private shipmentService: ShipmentASN
  ) {
    this.filters = new FilterPoData()
    this.deliverySchedule = new CreateDeliverySchedule()
    this.PoSearchDTO = new PoSearchDTO()
  }

  ngOnInit() {
    this.fetchData();
    this.initializeColumns();
    this.deliveryScheduleForm = this.fb.group({
      quantity: [null, Validators.required],
      deliveryDate: [null, Validators.required],
    });

    const selectedNo = history.state.selectedNo;
    if (selectedNo) {
      this.poNo = selectedNo;
      this.fetchData().then(() => {
        history.replaceState({ ...history.state, selectedNo: null }, '');
      });
    }

    this.vendorService.checkIfVendor()
    .then((response) => {
      this.isVendor = response.message.isVendor
      this.isPlantRole=response.message.isPlantRole

      if (this.isPlantRole){
        this.getPlantUserRole()
      }else{
        this.getPlantList();
      }

    }).catch((error) => {
      console.log(error)
    });

  }
  getPlantList() {
    this.shipmentService.getPlantList().then((res: any[]) => {
      res.forEach((data)=>{
        let plant:PlantWithCode = {
          plant__code:data.plant__code,
          name1: `${data.plant__code}-${data.name1}`
        }
        this.plantList.push(plant)
      })
    })
      .catch((error: any) => {
        console.log(error);
      });
  }

  getPlantUserRole(){
    this.shipmentService.getUserPlantByRole().then((res) => {
      res.message.forEach((data:any)=>{
        let plant:PlantWithCode = {
          plant__code:data.plant__code,
          name1: `${data.plant__code}-${data.name1}`
        }
        this.plantList.push(plant)
      })

    })
      .catch((error: any) => {
        console.log(error);
      });
  }

  showDialog(rowNode: any) {
    this.poItemNo = "";
    this.schedule_remaining_quantity = "";
    this.maxAllowedQuantity = 0;
    this.scheduleList = [];
    this.totalQuantity = 0;
    this.availableQuantity = 0;
    this.dateValidation = false
    if (rowNode) {
      this.selectedPODetail.node
      this.selectedPOZSERItemData=rowNode.zser_item
      this.po_agreement_no = this.selectedPODetail.node.data.pono
      this.poItemNo = rowNode.pono
      this.schedule_remaining_quantity = rowNode.schedule_remaining_quantity
      this.maxAllowedQuantity = rowNode.vcode
      this.selectedPODetail.node.children.forEach((element: any) => {
        if (element.data.pono === rowNode.pono) {
          this.scheduleList = element.children
        }
      });
      // this.scheduleList = rowNode.node.children
      // this.selectedChildKey = rowNode.node.key
      // this.selectedPerentKey = rowNode.parent.key
    }
    for (const schedule of this.scheduleList) {
      if (schedule.data.status === 0) {
        this.totalQuantity += schedule.data.vcode
      } else {
        this.totalQuantity += schedule.data.status
      }

    }
    this.availableQuantity = rowNode.schedule_remaining_quantity
    this.deliveryScheduleForm.get('quantity')?.setValue(this.availableQuantity)
    if(this.po_order_type === "ZSER"){
      this.isZserPOVisible = true;
    }else{
      this.visible = true;
    }
  }

  validateQuantity() {
    if (this.deliveryScheduleForm.get('quantity')?.value === 0) {
      this.quantityExceedsMax = true;
    }
    else if (this.deliveryScheduleForm.get('quantity')?.value > (this.availableQuantity ?? 0)) {
      this.quantityExceedsMax = true;
      this.saveButtonDisabled = true;
    } else {
      this.quantityExceedsMax = false;
      this.saveButtonDisabled = false;
    }
  }

  dateValidationMsg() {
    const selectedDate = this.deliveryScheduleForm.get('deliveryDate')?.value
    this.correctDate.setHours(0, 0, 0, 0);
    if (selectedDate < this.correctDate) {
      this.dateValidation = true
    } else {
      this.dateValidation = false
    }
  }

  onClose() {
    this.deliveryScheduleForm.reset()
    this.quantityExceedsMax = false
    this.visible = false
    this.selectedChildKey = null
    this.selectedPerentKey = null
  }

  onPageChange(event:any){
    this.currentPage=event.page + 1
    this.limit=event.rows
    this.fetchData()
  }


  async fetchData() {
    try {
     let data={
      page:this.currentPage,
      limit:this.limit,
      po_search_dto:this.PoSearchDTO
      }
      this.isLoading=true
      await this.purchaseOrder.getPageablePoList(data).then((res) =>{
        this.isLoading=false
       this.poList = res.message.po_list
        this.totalRecords = res.message.total_po  })
        .catch((error) => {
          this.isLoading=false
          console.log(error)
        });
      await this.auth.getLoggedInUser().
        then((res) => this.loggedInUsers = res).catch((error) => console.log(error))
      this.mappedData = this.poList?.map((po, index) => ({
        key: `parent_${index}`,
        data: {
          pono: po.poagreement_no,
          plant: po.plant,
          ddate: this.formatDate(po.document_date),
          vcode: po.vendor_code,
          name: po.name1,
          docType: po.order_type,
          invoice_no: po.invoice_no,
          status: po.status,
          // payment_status: item.po.payment_status,

        },
        children: po.itemsGetList.sort((a: any, b: any) => this.compareItemNo(a.item_no, b.item_no))
          .map((item: any, childIndex: any) => ({
            key: `child_${index}_${childIndex}`,
            data: {
              pono: item.item_no,
              ddate: item.material_code,
              vcode: this.formatNumber(item.quantity ?? 0),
              name: item.description,
              status: item.uom,
              a1: this.formatNumber(item.net_value ?? 0),
              b1: this.formatNumber(item.tax_amount ?? 0),
              c1: this.formatNumber(item.total ?? 0),
              d1: item.status,
              unit_price: this.formatNumber(item.unit_price ?? 0),
              per: item.per,
              currency: item.currency,
              availableQty: this.formatNumber(item.remaining_quantity ?? 0),
              schedule_remaining_quantity: this.formatNumber(item.schedule_remaining_quantity ?? 0),
              zser_item:[],
              // overall_limit: this.formatNumber(item.overall_limit ?? 0),
              // expected_value: this.formatNumber(item.expected_value ?? 0),
              actual_value: this.formatNumber(item.actual_value ?? 0)
            },
            children: item.scheduleGetList.sort((a: any, b: any) => this.compareItemNo(a.item_no, b.item_no))
              .map((shipment: any, shipmentIndex: any) => ({
                key: `shipment_${index}_${childIndex}_${shipmentIndex}`,
                data: {
                  pono: shipment.item_no,
                  ddate: this.formatDate(shipment.delivery_date),
                  vcode: shipment.quantity,
                  name: shipment.status,
                  status: shipment.actual_quantity ?? 0,
                }
              })),
            children1: item.zserItemList.sort((a: any, b: any) => this.compareItemNo(a.item_no, b.item_no))
              .map((zser_item: any, zser_itemIndex: any) => ({
                key: `zser_item_${index}_${childIndex}_${zser_itemIndex}`,
                data: {
                  item_no: zser_item.item_no,
                  service_no: zser_item.service_no,
                  short_text: zser_item.short_text,
                  quantity: this.formatNumber(zser_item.quantity ?? 0),
                  actual_quantity: this.formatNumber(zser_item.actual_quantity ?? 0),
                  un: zser_item.un,
                  gross_price: this.formatNumber(zser_item.gross_price ?? 0),
                  net_value: this.formatNumber(zser_item.net_value ?? 0),
                  currency: zser_item.currency,
                  tax_code: zser_item.tax_code,
                  unlimited_overfulfillment: zser_item.unlimited_overfulfillment,
                }
              }))
          }))
      }));

      this.files = this.mappedData ? [...this.mappedData] : [];
      this.applyExpandedStates(this.files || []);
      if (this.poNo) {
        this.mappedData = this.mappedData?.filter(data => data.data.pono === this.poNo);
      }
      if (this.currentNodePo) {

        let poNode: any = { node: this.mappedData?.find((m) => this.currentNodePo === m.data.pono) }
        if (poNode) {
          this.onClickPO(poNode,false);
        }
      }


    } catch (error) {
      this.isLoading=false
      console.error("Error fetching data:", error);
    }
  }

  formatNumber(value: any) {
    if (value == null) return '0.00';

    const num = typeof value === 'string' ? parseFloat(value) : value;

    if (typeof num !== 'number' || isNaN(num)) return value;

    // Round the number to two decimal places
    const roundedValue = Math.round(num * 100) / 100;

    const strNum = roundedValue.toString();

    // Check if it has trailing zeros after decimal or no decimal point
    if (!strNum.includes('.') || strNum.endsWith('.00')) {
      return roundedValue.toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    }

    return roundedValue.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  applyExpandedStates(nodes: TreeNode<any>[]) {
    for (const node of nodes) {
      if (node.key !== undefined && node.key === this.selectedPerentKey) {
        node.expanded = true;
      }

      if (node.children !== undefined) {
        for (const children of node.children) {
          if (children.key !== undefined && children.key === this.selectedChildKey) {
            children.expanded = true;
          }
        }
      }
    }

  }

  compareItemNo(a: string, b: string): number {
    const hasUnderscoreA = a.includes('_');
    const hasUnderscoreB = b.includes('_');

    if (hasUnderscoreA && hasUnderscoreB) {
      const [prefixA, numberA] = a.split('_');
      const [prefixB, numberB] = b.split('_');

      const prefixComparison = prefixA.localeCompare(prefixB);

      if (prefixComparison !== 0) {
        return prefixComparison;
      }

      const numberComparison = parseInt(numberA, 10) - parseInt(numberB, 10);
      return numberComparison;
    } else {
      const numericComparison = parseInt(a, 10) - parseInt(b, 10);
      return numericComparison;
    }
  }

  formatDate(dateString: string) {
    if (!dateString) return '';
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0'); // Pad with leading zero if single digit
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Pad with leading zero if single digit
    const year = date.getFullYear();
    const formattedDate = `${day}.${month}.${year}`;
    return formattedDate;
  }


  initializeColumns() {
    this.cols = [
      { field: 'vcode' },
      { field: 'pono' },
      { field: 'plant' },
      { field: 'ddate' },
      { field: 'name' },
      { field: 'docType' },
      { field: 'invoice_no' },
      { field: 'status' },
      // { field: 'payment_status' },
      // { field: 'b1' },
      // { field: 'c1' },
      // { field: 'd1' }
    ];
  }



  setButton(rowData: any): boolean {
    if (rowData.node.key.startsWith('child')) {
      return true
    }
    else {
      return false
    }
  }
  setViewButton(rowData: any): boolean {
    if (rowData.node.key.startsWith('parent')) {
      return true
    }
    else {
      return false
    }
  }

  onInputChange(event: any, field: string) {
    const fieldMapping: { [key: string]: string } = {
      vcode: 'vendor_code',
      pono: 'poagreement_no',
      plant: 'plant',
      ddate: 'document_date',
      name: 'name1',
      docType: 'order_type',
      invoice_no: 'invoice_no',
      status: 'status'
    };

    const inputValue = (event.target as HTMLInputElement)?.value;
    const dtoField = fieldMapping[field];
    if(inputValue !== ""){
      if (this.PoSearchDTO && dtoField) {
        (this.PoSearchDTO as any)[dtoField] = inputValue;
      }
    }else{
      if (this.PoSearchDTO && dtoField) {
        (this.PoSearchDTO as any)[dtoField] = null;
      }
    }
    this.currentPage=1
    this.fetchData()
  }
  onGlobalSearch(event: any) {
    if (event?.target?.value) {
      const searchText = event.target.value;
      this.tt?.filterGlobal(searchText, 'contains');
    }

  }

  async filterData() {

    this.filters!.company_code = this.companyCode
    this.filters!.plant = this.plant,
      this.filters!.doc_type = this.docType,
      this.filters!.doc_cat = this.docCat,
      this.filters!.poagreement_no = this.poAgreementNo,
      this.filters!.vendor_code = this.vendorCode,
      this.filters!.document_date = this.documentDate,
      this.filters!.status = this.status,
      this.filters!.valid_from = this.validFromDate,
      this.filters!.valid_to = this.validToDate


    const filterDate: any = {
      document_date: this.documentDate ? this.datePipe.transform(this.documentDate, 'yyyy-MM-dd') : undefined,
      valid_from: this.validFromDate ? this.datePipe.transform(this.validFromDate, 'yyyy-MM-dd') : undefined,
      valid_to: this.validToDate ? this.datePipe.transform(this.validToDate, 'yyyy-MM-dd') : undefined
    };
    this.filters!.document_date = filterDate.document_date
    this.filters!.valid_from = filterDate.valid_from
    this.filters!.valid_to = filterDate.valid_to

    const test = this.getFilteredData(this.filters);

    try {
      await this.purchaseOrder.filteredPoList(test).then((res) => this.poList = res.message)
        .catch((error) => console.log(error));
      this.mappedData = this.poList?.map((item, index) => ({
        key: `parent_${index}`,
        data: {
          pono: item.po.poagreement_no,
          ddate: this.formatDate(item.po.document_date),
          vcode: item.po.vendor_code,
          name: item.po.name1,
          status: item.po.status,
        },
        children: item.new_items.sort((a: any, b: any) => this.compareItemNo(a.item.item_no, b.item.item_no))
          .map((newItem: any, childIndex: any) => ({
            key: `child_${index}_${childIndex}`,
            data: {
              pono: newItem.item.item_no,
              ddate: newItem.item.material_code,
              vcode: newItem.item.description,
              name: newItem.item.quantity,
              status: newItem.item.uom,
              a1: newItem.item.net_value,
              b1: newItem.item.tax_amount,
              c1: newItem.item.total,
              d1: newItem.item.status,
            },
            children: newItem.shipments.sort((a: any, b: any) => this.compareItemNo(a.delivery_schedule.item_no, b.delivery_schedule.item_no))
              .map((shipment: any, shipmentIndex: any) => ({
                key: `shipment_${index}_${childIndex}_${shipmentIndex}`,
                data: {
                  pono: shipment.delivery_schedule.item_no,
                  ddate: this.formatDate(shipment.delivery_schedule.delivery_date),
                  vcode: shipment.delivery_schedule.quantity,
                  name: shipment.delivery_schedule.status,
                  // status: shipment.delivery_schedule.actual_quantity,
                }
              }))
          }))
      }));

    } catch (error) {
      console.error("Error fetching data:", error);
    }

  }

  getFilteredData(filter?: FilterPoData) {

    const filteredData: any = {}
    for (const key in filter) {
      if (filter[key] !== '' && filter[key] !== undefined) {
        filteredData[key] = filter[key];
      }
    }
    return filteredData;
  }

  toggleContentVisibility(): void {
    this.isContentVisible = !this.isContentVisible;
  }

  async createDeliverySchedule() {
    let new_date = this.datePipe.transform(this.deliveryScheduleForm.get('deliveryDate')?.value, 'yyyy-MM-dd');
    if (new_date !== null) {
      this.deliverySchedule!.poAgreementNo = this.po_agreement_no
      this.deliverySchedule!.poItemNo = this.poItemNo;
      this.deliverySchedule!.quantity = this.deliveryScheduleForm.get('quantity')?.value;
      this.deliverySchedule!.delivery_date = new_date;
      this.deliverySchedule!.vendor = this.loggedInUsers;
    }

    this.purchaseOrder.postDeliverySchedule(this.deliverySchedule).then((res) => {
      if (res.message.status === "Success") {
        this.messageService.add({ severity: "success", summary: 'Success', detail: res.message.message })
        this.fetchData();
      } else {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: res.message.message });
      }
      this.deliveryScheduleForm.reset()

    }).catch((error) => {
      this.deliveryScheduleForm.reset()
      console.log(error);
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'An error occurred while creating the delivery schedule.' }); // Add generic error message
    })
    this.visible = false

  }


  onClickPO(rowNode: any,isOpen=true) {
    this.currentNodePo=""
    this.currentNodePo = rowNode.node.data.pono
    this.po_order_type = rowNode.node.data.docType
    this.selectedPODetail = rowNode
    this.selectedPOData = [rowNode.node.data];
    this.selectedPOItemData = [];
    this.selectedPOScheduleData = [];
    this.po_no = rowNode.node.data.pono;

    rowNode.node.children.forEach((child: any) => {
      this.totalQuantity2 = 0
      child.data.zser_item=child.children1
      this.selectedPOItemData.push(child.data);
      child.children.forEach((grandChild: any) => {
        this.selectedPOScheduleData.push(grandChild.data);
        // this.totalQuantity2 += grandChild.data.vcode
        if (grandChild.data.status === 0) {
          this.totalQuantity2 += grandChild.data.vcode
        } else {
          this.totalQuantity2 += grandChild.data.status
        }
      });

      // let availableQuantity2 = child.data.vcode! - this.totalQuantity2!
      // child.data.availableQty = availableQuantity2
    });

    this.selectedPOScheduleData.sort((a, b) => {
      let aParts = a.pono.split('_').map(Number);
      let bParts = b.pono.split('_').map(Number);

      for (let i = 0; i < aParts.length; i++) {
        if (aParts[i] !== bParts[i]) {
          return aParts[i] - bParts[i];
        }
      }
      return 0;
    });
    if(this.po_order_type === "ZSER"){
      this.isZserPO = true;
    }else{
      this.isZserPO = false;
    }
    if(isOpen){
      this.sidebarVisible = true;
    }


  }

  // showScheduleDelivery(rowNode: any) {
  //   console.log(rowNode.pono)
  //   console.log(this.selectedPOScheduleData.forEach(element => {
  //     console.log(element.pono)
  //   }))
  //   this.visible1 = true;
  // }

  showScheduleDelivery(rowNode: any) {
    this.selectedPOScheduleData2 = [];

    const rowNodePonoPrefix = rowNode.pono;

    const filteredPOScheduleData = this.selectedPOScheduleData.filter(element => {
      const elementPonoPrefix = element.pono.split('_')[0];
      return elementPonoPrefix === rowNodePonoPrefix;
    });

    filteredPOScheduleData.forEach(element => {
      this.selectedPOScheduleData2.push(element)
    });

    this.visible1 = true;
  }

  getSeverity(status: string): string {
    if (!status) {
      return 'info';
    }

    switch (status) {
      case 'Open':
        return 'open';
      case 'Open for Schedule':
        return 'openforSchedule';
      case 'Open for Delivery':
        return 'openforDelivery';
      case 'Partial Delivered':
        return 'partialDelivered';
      case 'Delivered':
        return 'delivered';
      case 'Open Payment':
        return 'openPayment';
      case 'Paid':
        return 'paid';
      case 'Shipment Pending':
        return 'shipmentpending';
      case 'Shipment Created':
        return 'shipmentcreated';
      default:
        return 'info';
    }
  }


  getSeverityClass(severity: string): string {
    switch (severity) {
      case 'openforSchedule':
        return 'openforSchedule';
      case 'openforDelivery':
        return 'openforDelivery';
      case 'partialDelivered':
        return 'partialDelivered';
      case 'delivered':
        return 'delivered';
      case 'openPayment':
        return 'openPayment';
      case 'paid':
        return 'paid';
      case 'shipmentpending':
        return 'shipmentpending';
      case 'shipmentcreated':
        return 'shipmentcreated';
      case 'open':
        return 'open';
      default:
        return '';
    }
  }
  onCloseForExcelReport(){
    this.isExcel=false
    this.startDate=null
    this.endDate=null
    this.vendorNames=''
    this.plants=''
    this.poAgreementNos=''
    this.dateValidation1=false
  }
  onClickExcel(){
    this.isExcel=true
  }
  onDowunloadPoListByDate(){
    if (this.startDate != null && this.endDate != null) {

    let date:FilterDate = {
      startDate:this.datePipe.transform(this.startDate, 'yyyy-MM-dd'),
      endDate:this.datePipe.transform(this.endDate, 'yyyy-MM-dd HH:mm:ss'),
      vendorNames:this.vendorNames,
      plants:this.plants,
      poAgreementNos:this.poAgreementNos,
    }
    this.isLoading=true
    this.isExcel=false
    this.purchaseOrder.downloadPoByDate(date).then((res)=>{
      if(res.message === "No Record Found"){
        this.messageService.add({ severity: "info", summary: 'Info', detail: "No Data Found."})
      }else{
        const fileContent = res.filecontent;
        const blob = new Blob([new Uint8Array(fileContent)], {
          type: 'application/octet-stream'
        });

        const downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(blob);
        downloadLink.download = `po_report${date.startDate}_${date.endDate}.xlsx`;

        document.body.appendChild(downloadLink);
        downloadLink.click();
        this.messageService.add({ severity: "success", summary: 'Success', detail: "Po Report downloaded successfully."})
      }
      this.onCloseForExcelReport();
      this.isLoading=false

    }).catch((error)=>{
      console.log(error)
    })

  }
  }


  downloadExcel() {
    // Format data for each section of the sheet
    const formattedData1 = this.formatDataForExcel(this.selectedPOData);
    const formattedData2 = this.formatDataForExcel2(this.selectedPOItemData);
    const formattedData3 = this.formatDataForExcel3(this.selectedPOScheduleData);

    // Convert each formatted data to a worksheet format
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet([]);

    // Append the first list (PO List)
    XLSX.utils.sheet_add_json(ws, formattedData1, { origin: 'A1' });

    // Auto-size columns for the first section
    this.calculateColumnWidths(ws, formattedData1);

    // Get the next available row after the first list
    const rowOffset1 = formattedData1.length + 3; // Adding 2 to leave space between sections

    // Append the second list (Item Details) below the first one
    XLSX.utils.sheet_add_json(ws, formattedData2, { origin: `A${rowOffset1}` });

    // Auto-size columns for the second section
    this.calculateColumnWidths(ws, formattedData2);

    // Get the next available row after the second list
    const rowOffset2 = rowOffset1 + formattedData2.length + 2;

    // Append the third list (Delivery Info) below the second one
    XLSX.utils.sheet_add_json(ws, formattedData3, { origin: `A${rowOffset2}` });

    // Auto-size columns for the third section
    this.calculateColumnWidths(ws, formattedData3);

    // Create a new workbook and append the single sheet
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'PO Details');

    // Write the Excel file
    XLSX.writeFile(wb, 'po_details.xlsx');
}

formatDataForExcel(data: any[]): any[] {
  if (!data || data.length === 0) {
    return []; // Return an empty array if data is empty or undefined
  }

    return data.map(item => ({
        'Vendor Code': item.vcode,
        'PO/Agreement No': item.pono,
        'Plant': item.plant,
        'Document Date': item.ddate,
        'Name': item.name,
        'Document Type': item.docType,
        'Invoice No': item.invoice_no,
        'Status': item.status,
    }));
}

formatDataForExcel2(data: any[]): any[] {
  if (!data || data.length === 0) {
    return []; // Return an empty array if data is empty or undefined
  }

    return data.map(item => ({
        'Item No': item.pono,
        'Material Code': item.ddate,
        'Material Description': item.name,
        'Quantity': item.vcode,
        'UoM': item.staus,
        'Unit Price': item.unit_price,
        'Per': item.per,
        'Currency': item.currency,
        'Net Value': item.a1,
        'Tax Amount': item.b1,
        'Total Value': item.c1,
        'Status': item.d1,
    }));
}

formatDataForExcel3(data: any[]): any[] {
  if (!data || data.length === 0) {
    return []; // Return an empty array if data is empty or undefined
  }

    return data.map(item => ({
        'Item No': item.pono,
        'Delivery Date': item.ddate,
        'Quantity': item.vcode,
        'Actual Quantity': item.status,
        'Status': item.name,
    }));
}
  calculateColumnWidths(ws: XLSX.WorkSheet, data: any[]) {
    if (!data || data.length === 0) {
      return; // Return an empty array if data is empty or undefined
    }else{
      const colWidths: number[] = [];
      const keys = Object.keys(data[0]);

      keys.forEach((key, colIndex) => {
          let maxWidth = key.length;
          data.forEach(row => {
              maxWidth = Math.max(maxWidth, row[key] ? row[key].toString().length : 0);
          });
          colWidths[colIndex] = maxWidth + 2;
      });

      ws['!cols'] = colWidths.map(width => ({ wch: width + 2 }));
    }
    }

    validateDate() {
      if (this.startDate && this.endDate) {
        const difference = this.getDateDifference();
        if (difference > 12 || this.endDate < this.startDate) {
          this.dateValidation1 = true;
        } else {
          this.dateValidation1 = false;
        }
      }
    }

    getDateDifference(): number {
      if (this.startDate && this.endDate) {
        const start = new Date(this.startDate);
        const end = new Date(this.endDate);
        const diffTime = Math.abs(end.getTime() - start.getTime());
        const diffMonths = diffTime / (1000 * 3600 * 24 * 31); // approx. 30 days in a month
        return diffMonths;
      }
      return 0;
    }


}
